<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <ReceptionTop />
      <AppointmentsPages
        @show-create-appointment-model="showCreateAppointmentModel"
        @shift-appointment-content="shiftAppointmentContent"
      />

      <div class="col-12">
        <!-- table start -->
        <div class="card mb-4">
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <nav>
                <!-- <Search :PlaceHolder="placeHolderText" @search="handleSearch" /> -->
                <Search
                  :placeholder="'Srch.. name, phone, email, OPD/IPD'"
                  @onsearch="handleSearch"
                />
              </nav>
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      #Appointment ID
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Patient
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Appointment Date
                    </th>

                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Contacts
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Doctor
                    </th>

                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>

                <div v-if="tableLoading">
                  <div class="loader" v-if="apiLoading">
                    <div class="spinner"></div>
                    <p>Loading...</p>
                  </div>
                </div>

                <tbody v-if="appointments.length">
                  <tr v-for="user in appointments" :key="user.appointment_id">
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        #{{ user.appointment_id }}
                      </p>
                      <p class="text-xs text-secondary mb-0">
                        {{ user.clinic_name }}
                      </p>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div></div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ user.patient_name }}</h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ user.opd == null ? null : "OPD/" + user.opd }}
                          </p>
                          <p class="text-xs text-secondary mb-0">
                            {{ user.ipd == null ? null : "IPD/" + user.ipd }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        <Datetime :datetime="user.appointment_date" />
                      </p>
                      <p class="text-xs text-secondary mb-0">
                        <span
                          style="color: green"
                          v-if="
                            user.appointment_status == '1' ||
                            user.appointment_status == 1
                          "
                          >Attended</span
                        >
                        <span
                          style="color: black"
                          v-if="
                            user.appointment_status == '0' ||
                            user.appointment_status == null ||
                            user.appointment_status == ''
                          "
                          >Pending attendance..</span
                        >
                        <span
                          style="color: red"
                          v-if="user.appointment_status == '2'"
                          >Cancelled</span
                        >
                      </p>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{
                          user.opd == null
                            ? null
                            : "Phone: " + user.patient_phone
                        }}
                      </p>
                      <p class="text-xs text-secondary mb-0">
                        {{
                          user.patient_email == null
                            ? null
                            : "Email: " + user.patient_email
                        }}
                      </p>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        user.doc == null
                          ? "Unspecified"
                          : user.doc == "1"
                          ? "Unspecified"
                          : user.doc
                      }}</span>
                    </td>
                    <td class="align-middle">
                      <p class="text-xs font-weight-bold mb-1">
                        <!-- <button type="button" class="mycustom-neutral-button" data-identifymodel="requesttype" data-bs-toggle="modal"  
                        data-backdrop="static" data-keyboard="false"  data-bs-target="#showpatientinfo">
                        About Patient {{ user.patient_id }}
                      </button>. -->
                        <button
                          type="button"
                          class="mycustom-neutral-button"
                          @click="showPatientDetailsmodel(user.patient_id)"
                        >
                          About Patient
                        </button>
                        <button
                          v-if="
                            user.appointment_status == '0' ||
                            user.appointment_status == 0 ||
                            user.appointment_status == null
                          "
                          class="mycustom-success-button"
                          @click="
                            showStartVisitFromAppointmentModel(
                              user.appointment_id,
                              user.patient_name,
                              user.clinic_name,
                              user.opd
                            )
                          "
                        >
                          Start Visit
                        </button>
                      </p>
                      <p class="text-xs text-secondary mb-0">
                        <button
                          v-if="user.appointment_status == '0'"
                          class="mycustom-secondary-button"
                          @click="
                            showRescheduleAppointmentModel(user.appointment_id)
                          "
                        >
                          Reschedule</button
                        >.
                        <button
                          v-if="user.appointment_status == '0'"
                          @click="
                            showCancelAppointmentModel(
                              user.appointment_id,
                              user.patient_name,
                              user.clinic_name,
                              user.opd
                            )
                          "
                          class="mycustom-danger-button"
                        >
                          Cancel
                        </button>
                      </p>
                    </td>
                  </tr>
                </tbody>
                <div v-else>
                  <p class="tocenter-container" v-if="!apiLoading">
                    No Records found.
                  </p>
                </div>
              </table>
              <!-- Pagination   @page-change="handlePageChange" :current-page="currentPage" :total-pages="totalPags" -->
              <!-- <pagination :all-data="allData" @content-change="handleContentChange" /> -->
              <div v-if="apiLoading">Loading...</div>
              <pagination
                v-if="!apiLoading"
                :all-data="allData"
                @content-change="handleContentChange"
                @loader-set="loaderSet"
              />

              <!--  -->
            </div>
          </div>
        </div>
        <!-- table end -->
      </div>
    </div>
  </div>

  <CreateAppointmentModal
    v-if="showModalCreateAppointmentModel"
    @reload-content="reloadContent"
    @close="handleCloseCreateAppointmentmodel"
  />
  <ShowPatientModal
    v-if="showModalPatientDetailsModel"
    @close="handleClosePatientDetailsmodel"
    :patient_id="viewing_patient_id"
  />
  <RescheduleAppointment
    v-if="showModalRescheduleAppointment"
    @close="handleCloseRescheduleAppointmentmodel"
    :appointment_id="inFocusAppointmentId"
  />

  <StartVisitFromAppointment
    v-if="showModalStartVisitFromAppointment"
    @close="handleCloseStartVisitFromAppointmentmodel"
    :appointment_id="inFocusAppointmentId"
    :patient_name="inFocusPatientName"
    :clinic_name="inFocusClinicName"
    :opd="inFocusOpd"
  />
  <CancelAppointment
    v-if="showModalCancelAppointment"
    @close="handleCloseCancelAppointmentmodel"
    :appointment_id="inFocusAppointmentId"
    :patient_name="inFocusPatientName"
    :clinic_name="inFocusClinicName"
    :opd="inFocusOpd"
  />
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import Pagination from "../components/pagination.vue";
import Search from "../components/search.vue";
import Datetime from "../components/datetimeformat.vue";
import ReceptionTop from "./reception_top.vue";
import RescheduleAppointment from "./reschedule_appointment.vue";
import StartVisitFromAppointment from "./start_visit_from_appointment.vue";
import CancelAppointment from "./cancel_appointment.vue";
// import CreateAppointmentModal from './appointment_create.vue';
import CreateAppointmentModal from "../Patients/components/create_appointment.vue";
import AppointmentsPages from "../Patients/components/appointments_pages.vue";
import ShowPatientModal from "../Patients/components/patient_details.vue";

//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      showModalPatientDetailsModel: false,
      showModalCreateAppointmentModel: false,
      showModalRescheduleAppointment: false,
      showModalStartVisitFromAppointment: false,
      showModalCancelAppointment: false,
      inFocusAppointmentId: "",
      insearch_patient: "",
      inFocusPatientName: "",
      inFocusClinicName: "",
      inFocusOpd: "",
      appointments: "",
      viewing_patient_id: "",
      allData: {},
      apiLoading: true,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
    };
  },
  components: {
    Pagination,
    Search,
    ReceptionTop,
    CreateAppointmentModal,
    ShowPatientModal,
    Datetime,
    RescheduleAppointment,
    StartVisitFromAppointment,
    CancelAppointment,
    AppointmentsPages,
  },

  methods: {
    async handleSearch(searchTerm) {
      //console.log("the serch rem is " +searchTerm);
      try {
        this.apiLoading = true;
        const url = "search_appointment";
        const body = { search_param: searchTerm };

        const rs = await generalApiRequest(url, "GET", body, 1);

        this.allData = rs.data;
        this.apiLoading = false;
        console.log(this.allData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async shiftAppointmentContent(payload) {
      console.log(payload);
      this.apiLoading = true;
      try {
        const url = payload.url + "?page=1";
        const body = {};

        // const data = await getMethodRequest(url, body, 1);
        const data = await generalApiRequest(url, "GET", body, 1);
        // console.log("----------------------");
        // console.log(data.data.data);
        this.allData = data.data;
        this.apiLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    // ##########################modal exclusive

    showPatientDetailsmodel(patient_id) {
      this.viewing_patient_id = patient_id;
      this.showModalPatientDetailsModel = true;
    },

    handleClosePatientDetailsmodel() {
      this.showModalPatientDetailsModel = false; // Close the modal when 'close' event is triggered
    },

    showCreateAppointmentModel() {
      this.showModalCreateAppointmentModel = true;
    },

    handleCloseCreateAppointmentmodel() {
      this.showModalCreateAppointmentModel = false; // Close the modal when 'close' event is triggered
    },

    showRescheduleAppointmentModel(appointment_id) {
      this.inFocusAppointmentId = appointment_id;
      this.showModalRescheduleAppointment = true;
    },

    handleCloseRescheduleAppointmentmodel() {
      this.showModalRescheduleAppointment = false; // Close the modal when 'close' event is triggered
    },

    showStartVisitFromAppointmentModel(
      appointment_id,
      patient_name,
      clinic_name,
      opd
    ) {
      this.inFocusAppointmentId = appointment_id;
      this.inFocusPatientName = patient_name;
      this.inFocusClinicName = clinic_name;
      this.inFocusOpd = opd;
      this.showModalStartVisitFromAppointment = true;
    },

    handleCloseStartVisitFromAppointmentmodel() {
      this.showModalStartVisitFromAppointment = false;
    },

    showCancelAppointmentModel(appointment_id, patient_name, clinic_name, opd) {
      this.inFocusAppointmentId = appointment_id;
      this.inFocusPatientName = patient_name;
      this.inFocusClinicName = clinic_name;
      this.inFocusOpd = opd;
      this.showModalCancelAppointment = true;
    },

    handleCloseCancelAppointmentmodel() {
      this.showModalCancelAppointment = false;
    },

    // ##########################modal exclusive

    reloadContent() {
      this.callApi();
    },
    handleContentChange(contents) {
      // console.log("procceds");
      // console.log(contents);
      this.appointments = contents;
    },

    loaderSet(value) {
      if (value == true) {
        this.appointments = [];
      }
      this.tableLoading = value;
      //console.log(value);
      //this.apiLoading = value;
    },

    async callApi() {
      try {
        const url = "get_all_appointments?page=1";
        const body = {};

        // const data = await getMethodRequest(url, body, 1);
        const data = await generalApiRequest(url, "GET", body, 1);
        console.log("----------------------");
        console.log(data);
        this.allData = data.data;
        this.apiLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },

  mounted() {
    this.callApi();
  },
};
</script>
